import { render } from "./ThemeComponent.vue?vue&type=template&id=03a0cf2b"
import script from "./ThemeComponent.vue?vue&type=script&lang=js"
export * from "./ThemeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Theme/ThemeComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03a0cf2b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03a0cf2b', __exports__)) {
    api.reload('03a0cf2b', __exports__)
  }
  
  module.hot.accept("./ThemeComponent.vue?vue&type=template&id=03a0cf2b", () => {
    api.rerender('03a0cf2b', render)
  })

}


export default __exports__